(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/chat/chat-ui/assets/javascripts/write-message.js') >= 0) return;  svs.modules.push('/components/chat/chat-ui/assets/javascripts/write-message.js');
'use strict';

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
const contentEditableMockable = svs.components.lbUi.ContentEditable;
const _svs$ui = svs.ui,
  Button = _svs$ui.Button,
  ReactIcon = _svs$ui.ReactIcon;
const constants = svs.components.chat.chatData.constants;
const debounceRate = 300;
const defaultProps = {
  isCurrentUserAuthenticated: true
};
class WriteMessage extends React.Component {
  constructor() {
    var _this;
    super(...arguments);
    _this = this;
    _defineProperty(this, "state", {
      value: ''
    });
    _defineProperty(this, "handleInput", function () {
      let newValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      const processedVal = newValue.replace(/^\s*/, ''); 

      if (_this.debounceTimer) {
        clearTimeout(_this.debounceTimer);
      }
      _this.debounceTimer = setTimeout(() => {
        _this.props.onUpdateNewMessage(processedVal);
      }, debounceRate);
      _this.setState({
        value: processedVal
      });
    });
    _defineProperty(this, "handleSubmit", () => {
      const _this$props = this.props,
        disabled = _this$props.disabled,
        onSubmitMessage = _this$props.onSubmitMessage,
        onUpdateNewMessage = _this$props.onUpdateNewMessage;
      if (this.state.value === '') {
        return;
      }
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      onUpdateNewMessage(this.state.value);
      !disabled && onSubmitMessage(this.state.value);
      this.setState({
        value: ''
      });
    });
  }
  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.disabled !== this.props.disabled || nextState.value !== this.state.value;
  }
  render() {
    const _this$props2 = this.props,
      disabled = _this$props2.disabled,
      isCurrentUserAuthenticated = _this$props2.isCurrentUserAuthenticated;
    const value = this.state.value;
    const classNames = [];
    classNames.push('chat-add-comment--placeholder');
    if (value.length > 0) {
      classNames.push('chat-add-comment-placeholder-hidden');
    }
    return React.createElement("div", {
      className: "chat-container--add-comment",
      "data-testid": "chat-write-message"
    }, Boolean(isCurrentUserAuthenticated) && React.createElement(React.Fragment, null, React.createElement("div", {
      className: "relative"
    }, React.createElement("div", {
      className: "chat-add-comment"
    }, React.createElement(contentEditableMockable.ContentEditable, {
      "aria-describedby": "chat-add-comment--counter",
      "aria-label": value.length > 0 ? value : 'Skriv ett meddelande',
      className: "chat-add-comment--text qa-chat-textfield",
      "data-testid": "chat-textfield",
      maxLength: constants.MAX_CHARACTER_COUNT,
      onChange: this.handleInput,
      onEnter: this.handleSubmit,
      value: value
    }), React.createElement(Button, {
      "aria-disabled": disabled || value.length === 0,
      "aria-label": "Skicka",
      className: "chat-add-comment--create-btn icon-button qa-send-chat-message icon-button ".concat(disabled || value.length === 0 ? 'disabled' : ''),
      "data-testid": "send-chat-message",
      onClick: this.handleSubmit
    }, React.createElement(ReactIcon, {
      icon: "send",
      size: "400"
    }))), React.createElement("div", {
      "aria-hidden": "true",
      className: "chat-add-comment-placeholder-container"
    }, React.createElement("div", {
      className: classNames.join(' '),
      ref: this.placeholderRef
    }, "Skriv ett meddelande..."))), React.createElement("span", {
      className: "chat-add-comment--counter fc-grey-800 f-center f-100 qa-char-count",
      id: "chat-add-comment--counter"
    }, "".concat(constants.MAX_CHARACTER_COUNT - value.length, " tecken kvar"))), !isCurrentUserAuthenticated && 'Du måste logga in för att kunna skriva i chatten.');
  }
}
WriteMessage.defaultProps = defaultProps;
setGlobal('svs.components.chat.chatUi.WriteMessage', WriteMessage);

 })(window);